module.exports = __webpack_public_path__ + "img/dummy4.a753150.jpg";